// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import type { Node } from 'react';

type Props = {
  +children?: Node | Node[];
  +handleCheckpoint?: () => void;
  +elementId?: string;
  +disabled: boolean;
  +offset: number;
};

export default class InfiniteScroll extends Component<Props, void> {
  constructor(props: Props) {
    super(props);
  }

  // Only in browser
  componentDidMount() {
    const { elementId } = this.props;
    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.addEventListener('scroll', this.handleScrollElement, false);
      }
    } else {
      window.addEventListener('scroll', this.handleScrollGlobal);
    }
  }

  componentWillUnmount() {
    const { elementId } = this.props;
    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.removeEventListener('scroll', this.handleScrollElement, false);
      }
    } else {
      window.removeEventListener('scroll', this.handleScrollGlobal);
    }
  }

  handleCheckpointReached() {
    const { disabled, children, handleCheckpoint } = this.props;
    if (!disabled && children && !!handleCheckpoint) {
      handleCheckpoint();
    }
  }

  handleScrollElement = (event: Event) => {
    const { offset } = this.props;
    const children = (event.target: any).children[0];
    if (!children) return;
    const r = children.offsetHeight - ((event.target: any).offsetHeight + (event.target: any).scrollTop);
    if (r <= offset) {
      this.handleCheckpointReached();
    }
  };

  handleScrollGlobal = (event: Event) => {
    const { children, offset } = this.props;
    if (!children) return;
    if (window.innerHeight + window.scrollY + offset >= (event.target: any).body.offsetHeight) {
      this.handleCheckpointReached();
    }
  };

  render() {
    const { children } = this.props;
    return children || null;
  }
}

InfiniteScroll.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  handleCheckpoint: PropTypes.func.isRequired,
  elementId: PropTypes.string,
  disabled: PropTypes.bool,
  offset: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/InfiniteScroll/InfiniteScroll.jsx